module.exports = __webpack_public_path__ + "img/gb.79790891.png";